import { render, staticRenderFns } from "./OrderItemsSection.vue?vue&type=template&id=6dbf4f0e"
import script from "./OrderItemsSection.vue?vue&type=script&lang=js"
export * from "./OrderItemsSection.vue?vue&type=script&lang=js"
import style0 from "./OrderItemsSection.vue?vue&type=style&index=0&id=6dbf4f0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports